import { Page } from 'blocks/editor/model';
import React from 'react';
import styles from './page_switcher.css';

function allRoutes(page: Page): string[][] {
  const routes: string[][] = [];
  function visit(page: Page, route: string[]) {
    routes.push(route);
    page.subPages.forEach((subPage) => {
      visit(subPage, route.concat([subPage.name]));
    });
  }
  visit(page, []);
  return routes;
}

export function PageSwitcher({ page, base }: { page: Page; base: string }) {
  const [active, setActive] = React.useState(false);
  React.useEffect(() => {
    const listener = (event: KeyboardEvent) => {
      if (event.key === '/') {
        setActive((state) => !state);
      }
    };
    window.addEventListener('keydown', listener);
    return () => {
      window.removeEventListener('keydown', listener);
    };
  }, []);
  if (!active) {
    return null;
  }
  return (
    <div className={styles.pin}>
      <div className={styles.switcher}>
        {allRoutes(page).map((route) => (
          <div key={route.join('/')}>
            <a className={styles.link} href={`${base}/${route.join('/')}`}>
              {route.length === 0 ? 'Home' : route.join(' / ')}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
